enum CreditCardType {
    Amex = 'Amex',
    Discover = 'Discover',
    DinersClub = 'DinersClub',
    MasterCard = 'MasterCard',
    Visa = 'Visa',
    JCB = 'JCB',
}

interface ICreditCardDto {
    name: CreditCardType;
    css: string;
    image: string;
}

interface ICreditCardPresentation {
    type: CreditCardType;
    className: string;
}

export { ICreditCardDto, ICreditCardPresentation, CreditCardType };
